// @flow

// setup container for the functions
window.reece = window.reece || {};

import "@reece-trs-online/components/dist/postcode-update.js";
import "@reece-trs-online/components/dist/add-to-cart.js";

import "../dependencies/classie.js";
import switchAccount from "./switch-account.js";
import * as textSlider from "../../templates/components/header-value-proposition/_header-value-proposition.js";
import header from "../../templates/components/header/_header.js";
import * as account from "../../templates/components/header-top/_header-top.js";
import navigation from "../../templates/components/navigation/_navigation.js";
import btt from "../../templates/components/footer-main/_footer-main.js";
import * as wishlist from "./wishlist.js";
import lazyImg from "../lazy-img/index.js";
import * as menu from "../menu/index.js";
import * as siteMessage from "../site-message/index.js";

// load the functions when DOM is ready
document.addEventListener("DOMContentLoaded", function() {
  try{ menu.render(); } catch(e) { console.error(e); }
  try{ wishlist.init(); } catch(e) { console.error(e); }
  try{ switchAccount.init(); } catch(e) { console.error(e); }
  try{ textSlider.init(); } catch(e) { console.error(e); }
  try{ header.init(); } catch(e) { console.error(e); }
  try{ account.init(); } catch(e) { console.error(e); }
  try{ navigation.init(); } catch(e) { console.error(e); }
  try{ btt.init(); } catch(e) { console.error(e); }
  try{ lazyImg.init(); } catch(e) { console.error(e); }
  try{ siteMessage.init(); } catch(e) { console.error(e); }
});
